import { useTranslation } from "react-i18next";
import { isAnyPresent, makeHistory } from "../../HistoryUtils";
import HistoryContainerAndTitle from "./HistoryContainerAndTitle";
import SimpleArrayOfValues from "./SimpleArrayOfValues";

const ChipHistory = ({ anamnesisHistory }) => {
    const { t } = useTranslation();
    const history = makeHistory(anamnesisHistory);
    const chipData = history.getLatestSubDataRows("chipMutationData");
    const isVisible = isAnyPresent(anamnesisHistory, [
        "chipMutationData",
    ]);
    return (
        <HistoryContainerAndTitle title={t(`anamnesis.chip.title`)} isVisible={isVisible}>
            <SimpleArrayOfValues
                {...{
                    label: ``,
                    array: chipData,
                    questionsToTranslate: ["source"],
                    translationKey: "anamnesis.chip.source",
                }}
            />
        </HistoryContainerAndTitle>
    );
};

export default ChipHistory;
